import { motion } from "framer-motion";

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      className="relative bg-[#0A0A0C] pt-24 pb-10 border-t border-white/5 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="absolute inset-0 grid-bg opacity-[0.06] pointer-events-none" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-radial-red opacity-50 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        {/* Massive logo */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="relative"
        >
          <h2 className="font-display text-[88px] sm:text-[160px] lg:text-[240px] leading-[0.85] tracking-tighter font-medium text-white">
            Blude
            <span className="text-[#FF2400]">.</span>
          </h2>
          <div className="absolute bottom-3 right-0 sm:right-4 hidden md:flex items-center gap-2 text-white/40 font-mono text-[11px] tracking-widest">
            <span className="dot-pulse" />
            <span>LIFE SCIENCE &amp; TECH · MADURAI · INDIA</span>
          </div>
        </motion.div>

        <div className="mt-10 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="text-blude-textDim max-w-md leading-relaxed text-justify">
              Smart solutions for complex biological challenges. Bridging the
              gap between crisis and survival - for the moments that matter
              most.
            </p>
          </div>
          <div className="lg:col-span-3">
            <div className="eyebrow-dim mb-4">EXPLORE</div>
            <ul className="space-y-2 text-[14px] text-white/70">
              {[
                ["company", "Company"],
                ["focus", "Focus Areas"],
                ["science", "Science"],
                ["pipeline", "Pipeline"],
                ["platforms", "Platforms"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    data-testid={`footer-link-${id}`}
                    className="hover:text-[#FF6A4D] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <div className="eyebrow-dim mb-4">LEGAL</div>
            <ul className="space-y-2 text-[14px] text-white/70">
              <li>
                <a className="hover:text-[#FF6A4D] transition-colors" href="#privacy">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a className="hover:text-[#FF6A4D] transition-colors" href="#terms">
                  Terms of Use
                </a>
              </li>
              <li>
                <a className="hover:text-[#FF6A4D] transition-colors" href="#a11y">
                  Accessibility Statement
                </a>
              </li>
            </ul>
            <div className="eyebrow-dim mt-8 mb-2">CONTACT</div>
            <a
              href="mailto:contactus@blude.in"
              className="text-white/80 hover:text-[#FF6A4D] transition-colors text-sm"
            >
              contactus@blude.in
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] font-mono tracking-widest text-white/40">
          <span>© 2025 BLUDE LIFE SCIENCE AND TECH LLP. ALL RIGHTS RESERVED.</span>
          <span>RAM NAGAR · MADURAI - 625 017</span>
        </div>
      </div>
    </footer>
  );
};
